module.exports = __webpack_public_path__ + "jtails-build/img/person.beb3b6f3.svg";